import { createSlice } from '@reduxjs/toolkit';
import ReducerRegistry from '../../base/redux/ReducerRegistry';
const KEY_NAME = 'features/mobile-temp';
const initialState = {
    loading: false,
    isShowModal: false,
    modalComponent: undefined,
    modalProps: undefined,
    transparentBackground: true,
};
const tempConfigSlice = createSlice({
    name: KEY_NAME,
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload.loading;
            state.transparentBackground = action.payload.transparentBackground;
        },
        showModal: (state, action) => {
            state.isShowModal = true;
            state.modalComponent = action.payload?.modalComponent ?? state.modalComponent;
            state.modalProps = action.payload?.modalProps;
        },
        hideModal: (state) => {
            state.isShowModal = false;
            state.modalComponent = undefined;
            state.modalProps = undefined;
        }
    }
});
ReducerRegistry.register(KEY_NAME, tempConfigSlice.reducer);
export const { setLoading, showModal, hideModal } = tempConfigSlice.actions;
export default tempConfigSlice.reducer;
